import { Stack, Text } from "@fluentui/react";
import { LineChartComponent } from "../../../../ChartComponents/LineChartFluent";
import { featureChartStackStyle, featureChartTitleStyle } from "../ExploreFeatures.styles";
import { FeatureChartProps } from "../ExploreFeatures.interfaces";
import { NoFeatureSelectedState } from "./FeatureStateMessages";

export const FeatureChart = ({
  chartData,
  chartHeight,
  chartTitle,
  selectedFeatures,
  showDataTable
}: FeatureChartProps) => {
  if (!selectedFeatures.length) {
    return <NoFeatureSelectedState />;
  }

  if (!chartData.lineChartData?.length) {
    // No data to display, return null or a placeholder if needed
    return null;
  }

  return (
    <Stack style={featureChartStackStyle}>
      <Text styles={featureChartTitleStyle}>{chartTitle}</Text>
      <LineChartComponent
        key={`feature-chart-${showDataTable}-${selectedFeatures.join(",")}`}
        data={chartData}
        height={chartHeight}
        allowResize={true}
        legendsOverflowText="More..."
      />
    </Stack>
  );
};
